import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { fechaMX } from "@/lib/format";

const hoy = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const cartaVacia = () => ({
  encabezado: "AVISO IMPORTANTE A NUESTROS CLIENTES", asunto: "", saludo: "Estimados clientes:",
  cuerpo: "", fecha: hoy(), firma: "Departamento Comercial y Logística",
});

export function CartaCampos({ carta, onChange }) {
  const set = (k) => (e) => onChange({ ...carta, [k]: e.target.value });
  return (
    <div className="space-y-3" data-testid="carta-campos">
      <div className="grid grid-cols-1 sm:grid-cols-[1fr_160px] gap-3">
        <div><Label>Encabezado</Label><Input value={carta.encabezado} onChange={set("encabezado")} data-testid="carta-encabezado" /></div>
        <div><Label>Fecha de la carta</Label><Input type="date" value={carta.fecha} onChange={set("fecha")} data-testid="carta-fecha" /></div>
      </div>
      <div><Label>Asunto</Label><Input value={carta.asunto} onChange={set("asunto")} placeholder="Ej. Reprogramación de entregas" data-testid="carta-asunto" /></div>
      <div><Label>Saludo</Label><Input value={carta.saludo} onChange={set("saludo")} data-testid="carta-saludo" /></div>
      <div>
        <Label>Texto de la carta</Label>
        <Textarea rows={8} value={carta.cuerpo} onChange={set("cuerpo")} placeholder="Escribe cada párrafo separado por un renglón (Enter)." data-testid="carta-cuerpo" />
      </div>
      <div><Label>Firma (departamento)</Label><Input value={carta.firma} onChange={set("firma")} data-testid="carta-firma" /></div>
    </div>
  );
}

export function CartaHoja({ carta, headerRef, bodyRef }) {
  const parrafos = (carta.cuerpo || "").split(/\n+/).map((p) => p.trim()).filter(Boolean);
  return (
    <div className="bg-white text-gray-900 shadow mx-auto" style={{ width: "750px" }} data-testid="carta-hoja">
      <div ref={headerRef} className="bg-white">
        <div className="grid grid-cols-[auto_1fr_auto] gap-6 items-start bg-gray-50 px-3 py-3">
          <div className="text-center">
            <img src="/logo-cooper.png" className="h-16 w-16 object-contain rounded-lg mx-auto" alt="Cooper Slip" />
            <div className="text-xs mt-1">Cooper Slip</div>
          </div>
          <div className="text-center text-sm font-bold leading-snug pt-3">
            <p>Cuando tu cliente queda bien, Tu quedas mejor.</p>
            <p>Elije las duelas que respaldan a tu negocio</p>
          </div>
          <div className="text-right">
            <h2 className="text-2xl font-extrabold tracking-tight leading-tight">AVISO<br />IMPORTANTE</h2>
            <p className="text-sm mt-1"><span className="font-bold">Fecha:</span> {fechaMX(carta.fecha)}</p>
          </div>
        </div>
        <div className="border-t-4 border-black" />
      </div>
      <div ref={bodyRef} className="bg-white px-8 pt-7 pb-12 text-sm leading-relaxed">
        <p className="text-base font-extrabold tracking-wide text-center mb-1">DUELAS COOPER</p>
        {carta.encabezado && <p className="text-[15px] font-bold text-center mb-5">{carta.encabezado}</p>}
        {carta.asunto && <p className="mb-5"><b>Asunto:</b> {carta.asunto}</p>}
        {carta.saludo && <p className="mb-3">{carta.saludo}</p>}
        {parrafos.map((p, i) => <p key={i} className="mb-3 text-justify">{p}</p>)}
        <div className="mt-9" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p className="font-bold">Atentamente,</p>
          <p className="mt-1.5">Duelas Cooper</p>
          {carta.firma && <p>{carta.firma}</p>}
        </div>
      </div>
    </div>
  );
}
